import type { ColumnDef } from '@tanstack/react-table'
import type { StockoutSignal } from '@/lib/api-client'
import { formatCurrency } from '@/lib/utils'

interface Opts {
  demo: boolean
  mask: (skuId: number, name: string) => string
}

export function getStockoutColumns({ demo, mask }: Opts): ColumnDef<StockoutSignal>[] {
  const cols: ColumnDef<StockoutSignal>[] = [
    {
      accessorKey: 'sku',
      header: 'SKU',
      cell: ({ row }) => (
        <span className="font-medium text-text-dark">{mask(row.original.skuId, row.original.sku)}</span>
      ),
    },
    {
      accessorKey: 'branch',
      header: 'Branch',
      cell: ({ row }) => <span className="text-[13px]">{row.original.branch}</span>,
    },
    {
      accessorKey: 'month',
      header: 'Month',
      cell: ({ row }) => (
        <span className="inline-flex rounded-full bg-warning/10 px-2 py-0.5 text-[12px] font-medium text-warning">
          {row.original.month}
        </span>
      ),
    },
    {
      accessorKey: 'normalQtyMo',
      header: 'Normal/mo',
      cell: ({ row }) => (
        <span className="text-[13px]">
          {row.original.normalQtyMo}u <span className="text-text-muted">→ 0</span>
        </span>
      ),
    },
    {
      accessorKey: 'othersSelling',
      header: 'Others active',
      cell: ({ row }) => (
        <span className="text-[13px] text-text-muted">{row.original.othersSelling} branches</span>
      ),
    },
  ]
  if (!demo) {
    cols.push({
      accessorKey: 'estAtRisk',
      header: 'Est. at risk',
      cell: ({ row }) => <span className="text-[13px] text-destructive">{formatCurrency(row.original.estAtRisk)}</span>,
    })
  }
  return cols
}
